import { MapProperty } from 'cadenza/map/map-property';
import type { Map } from 'cadenza/map/map';

export function getActionContext (map: Map) {
  return { isEditingLayer: map ? !!map.get(MapProperty.EDITING_LAYER) : false, map };
}
